import { connect } from '../../../common/components/runtime-context';
import forDevice from '../../../common/hoc/for-device';
import SearchResultsDesktopList from './search-results-desktop-list';
import SearchResultsMobileList from './search-results-mobile-list';

const SearchResultsList = forDevice(SearchResultsMobileList, SearchResultsDesktopList);

import { type Actions, type AppState } from '../../../common/types';

const mapRuntimeToProps = (_state: AppState, _ownProps: {}, actions: Actions) => ({
  onPostLikeClick: actions.incrementPostLikeCount,
});

export default connect(mapRuntimeToProps)(SearchResultsList);
